import { render, staticRenderFns } from "./add-section-card-title-description.vue?vue&type=template&id=71bd07c8&"
import script from "./add-section-card-title-description.vue?vue&type=script&lang=js&"
export * from "./add-section-card-title-description.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports